import React from 'react';
import { useDispatch } from 'react-redux';
import { removeCartItem, addProduct, reduceCartItem } from './../../../redux/Cart/cart.actions';
import Remove from './../../../assets/remove.png';
import * as Icon from 'react-feather';
import './../styles.scss';



const Item = (product) => {
  const dispatch = useDispatch();
  var nf = new Intl.NumberFormat();

  const {
    price,
    pname,
    image,
    pbrand,
    quantity,
    documentID
  } = product;

  const handleRemoveCartItem = (documentID) => {
    dispatch(
      removeCartItem({
        documentID
      })
    );
  }

  const handleAddProduct = (product) => {
    dispatch(
      addProduct(product)
    )
  }

  const handleReduceItem = (product) => {
    dispatch(
      reduceCartItem(product)
    );
  }

  return (
    <div className="cartItem" border="0" cellSpacing="0" cellPadding="10">
      <div>
        <div className="each_cart_itm">
          <div className='column-1'>
            <img className="pimage" src={image} alt={pname} />
            <div className='block'>
              <span className='pname'>{pname}</span>
              {/* <span><p>Brand:</p>{pbrand}</span> */}
            </div>
          </div>
          {/* <span className='txt'>Quantity:</span> */}
          <div className='qty-column'>
            <div className="itm-quantity">

              <span className="cartBtn"
                onClick={() => handleReduceItem(product)}>
                {/* {<Icon.ArrowLeftCircle className='arrows' />} */}
                -
              </span>
              <div className='sep' />
              <span className="quantity">
                {quantity}
              </span>
              <div className='sep' />
              <span className="cartBtn"
                onClick={() => handleAddProduct(product)}>
                {/* {<Icon.ArrowRightCircle className='arrows' />} */}
                +
              </span>
            </div>
            <td className="price">
              <span className='top-span'>{'\u20A6'}{nf.format(price)}</span>
              <span className='bottom-span'>{'\u20A6'}{nf.format(price)} X {quantity} item</span>
            </td>
          </div>
          <div className='btm-opt'>
            <div className='each-flex topg'><Icon.Heart className='smaller'/><span>Add to wishlist</span></div>
            <div className='each-flex' onClick={() => handleRemoveCartItem(documentID)}><Icon.XCircle className='smaller'/><span>Remove item</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Item;
